import { render } from "./ProjectSettingsAccointAddTarget.vue?vue&type=template&id=2a73f1cb"
import script from "./ProjectSettingsAccointAddTarget.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsAccointAddTarget.vue?vue&type=script&lang=js"

import "./ProjectSettingsAccointAddTarget.vue?vue&type=style&index=0&id=2a73f1cb&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__